import { render } from "./VerificationAndQueryInput.vue?vue&type=template&id=5077d0ed&scoped=true"
import script from "./VerificationAndQueryInput.vue?vue&type=script&lang=js"
export * from "./VerificationAndQueryInput.vue?vue&type=script&lang=js"

import "./VerificationAndQueryInput.vue?vue&type=style&index=0&id=5077d0ed&lang=scss"
import "./VerificationAndQueryInput.vue?vue&type=style&index=1&id=5077d0ed&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5077d0ed"]])

export default __exports__